import type {EmbedField, RichTextField} from '@prismicio/types';
import {usePrismicTypeGuards} from '#imports';

export type VideoPlayerProps = {
    src: string;
    title: string;
    cover: string;
    size?: 'large' | 'medium' | 'small';
};

export function useVideoEmbedPlayer() {
    const {hasProperty} = usePrismicTypeGuards();

    function getEmbedSrc(video: EmbedField | null | undefined): string {
        const html = video?.html;
        return html?.match(/src="([^"]*)"/)?.[1] || '';
    }

    function getRichTextPlainText(field: RichTextField | null | undefined): string {
        if (!field) return '';
        return field.map((node) => (hasProperty(node, 'text') ? node.text : '')).join('');
    }

    function mapToVideoPlayerProps({
        video,
        title,
        cover,
        size,
    }: {
        video: EmbedField | null | undefined;
        title: RichTextField | null | undefined;
        cover?: {url?: string | null} | null;
        size?: 'large' | 'medium' | 'small' | null;
    }): VideoPlayerProps {
        return {
            src: getEmbedSrc(video),
            title: getRichTextPlainText(title),
            cover: cover?.url || '',
            size: size ?? undefined,
        };
    }

    return {getEmbedSrc, mapToVideoPlayerProps};
}
